export function Button({ as = "button", href, onClick, variant = "primary", children }) {
  const className = `btn ${variant}`;
  if (as === "a") {
    return (
      <a className={className} href={href} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <button className={className} type="button" onClick={onClick}>
      {children}
    </button>
  );
}

